export default {
  questionType: {
    text: 'Text',
    date: 'Date',
    single: 'Single Selector',
    multiple: 'Multiple Selector',
    attachment: 'Attachment',
    link: 'Agreement Link',
    location: 'Location',
    country: 'Country/Region',
    province: 'Province',
    city: 'City',
    nationality: 'Nationality',
    language: 'Language',
    nps: 'NPS',
    stars: 'Stars Rating Question',
    repeatGroup: 'Repeat Group',
    dateRange: 'Date Range'
  },
  prefillSource: {
    none: 'No prefill',
    candidateName: 'Candidate Name',
    candidateMobile: 'Candidate Mobile',
    candidateEmail: 'Candidate Email',
    jobTitle: 'Job Title',
    resumeEducation: 'Resume Education',
    resumeWork: 'Resume Work Experience'
  }
}
